/* JE68 wishlist (favoriter) – delad klient-logik, site-wide.
   Lagrar {id, handle} i localStorage. Sköter hjärt-knappar ([data-wish-id]) och räknare ([data-wish-count]). */
(function () {
  var KEY = 'je_wishlist_v2';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    emit();
  }
  function has(id) {
    id = String(id);
    return read().some(function (x) { return String(x.id) === id; });
  }
  function add(item) {
    if (!item || !item.id) return;
    var l = read();
    if (!l.some(function (x) { return String(x.id) === String(item.id); })) {
      l.push({ id: String(item.id), handle: item.handle || '' });
      save(l);
    }
  }
  function remove(id) {
    id = String(id);
    save(read().filter(function (x) { return String(x.id) !== id; }));
  }
  function toggle(item) {
    if (has(item.id)) { remove(item.id); return false; }
    add(item); return true;
  }
  function count() { return read().length; }

  var listeners = [];
  function subscribe(fn) { listeners.push(fn); }
  function emit() {
    updateCounts();
    listeners.forEach(function (f) { try { f(); } catch (e) {} });
    try { document.dispatchEvent(new CustomEvent('je:wish:change')); } catch (e) {}
  }

  function updateCounts() {
    var n = count();
    var els = document.querySelectorAll('[data-wish-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n === 0) { els[i].setAttribute('hidden', ''); }
      else { els[i].removeAttribute('hidden'); }
    }
  }

  function syncButtons(root) {
    var btns = (root || document).querySelectorAll('[data-wish-id]');
    for (var i = 0; i < btns.length; i++) {
      var on = has(btns[i].getAttribute('data-wish-id'));
      btns[i].classList.toggle('is-on', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wish-id]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle({ id: btn.getAttribute('data-wish-id'), handle: btn.getAttribute('data-wish-handle') });
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  window.JEWishlist = {
    read: read, has: has, add: add, remove: remove, toggle: toggle,
    count: count, subscribe: subscribe, syncButtons: syncButtons
  };

  function init() { syncButtons(); updateCounts(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  // Synka mellan flikar
  window.addEventListener('storage', function (e) { if (e.key === KEY) emit(); });
})();
